import styled from 'styled-components';

export const OrderTrackPopUpStyled = styled.div`
.orderTrackDetails {
    .patientDetails {
        display: flex;
        align-items: center;
        border-bottom: 1px solid #e3e9ef;
        padding: 23px 42px 14px 24px;

        .patientImage {
            margin-right: 12px;
        }

        .patientInitals {
            div: nth-child(1) {
                font-size: 14px;
                font-weight: 600;
                color: #78909C;
            }
            div: nth-child(2) {
                font-size: 17px;
                font-weight: 600;
                color: #031A32;
            }
        }
        .pomBadge {
            margin-left: 206px;
            @media (max-width: 430px) {
                margin-left: 188px;
            }
            @media (max-width: 390px) {
                margin-left: 148px;
            }
            @media (max-width: 360px) {
                margin-left: 118px;
            }
        }
    }
    .secureImage{
        margin: 3px 0 0 5px
    }
    .font-bold {
        font-weight: 700;
        font-size: 16px;
    }

    .padding-sm {
       padding-left: 12px;
    }

    .pharmacyContainer {
        border: 1px solid #e3e9ef;
        border-radius: 8px;
    }

    .pharmacyDetails {
        padding: 12px;
        font-size: 14px;
        color: #78909C;
        background: #FFFFFF;
        border-bottom: 1px solid #e3e9ef;
        
        .pharmacyText {
            padding-left: 8px;
        }
    }

    .extra-padding {
        padding-left: 8px;
        font-weight: 600;
    }

    .pharmacyContact {
        display: flex;
        font-size: 12px;
        align-items: center;
        justify-content: flex-end;
        padding-right: 16px;
        background: ${(props) => props?.theme?.color?.extraLightGray};

        a {
          text-decoration: none;
          color: inherit;
          display: flex;
          align-items: center;
        }
     }

     .paymentDetails {
        .padding-left {
            padding-left: 16px;
            font-weight: 600;
        }

        .padding-right {
            padding-right: 16px;
            font-weight: 600;
        }

        .paymentDetailsInner {
            border: 1px solid #e3e9ef;
            border-radius: 8px;
            align-items: center;
            padding: 16px 0;
            background:#fff;

            .hr-line {
                height: 2px;
                background: ${(props) => props?.theme?.color?.borderLight};;
                width: 100%;
                margin: 12px 0;
            }

            .pd-2 {
                margin-right: 8px;
             }
        }
     }
}
`;
